import React from 'react';
import styled from 'styled-components';

import { Switch, Text, theme } from 'components';
import { useContactState } from './hooks';

const HoldAppointment: React.FC = () => {
  const [contactState, updateContactState] = useContactState();

  return (
    <HoldAppointmentContainer>
      <Text strong>HOLD SHOWINGS IN QUEUE</Text>
      <Switch
        checkedChildren="On"
        unCheckedChildren="Off"
        checked={!!contactState.holdAppointments}
        onChange={checked => {
          updateContactState({ holdAppointments: checked });
        }}
      />
      <div>
        Once a showing is fully Confirmed, hold it in the admin queue so that
        final phone call can be made to the Concierge.
      </div>
    </HoldAppointmentContainer>
  );
};

export default HoldAppointment;

const HoldAppointmentContainer = styled.div`
  display: grid;
  gap: 16px;
  justify-items: center;
  border: 1px solid ${theme.gray8};
  width: 90%;
  padding: 16px;
`;
